import { CalendarSettingsType } from '../calendar-types';

export function getScaleItemWidth(settings: Partial<CalendarSettingsType>) {
  const { stepWidth = 100, startingHour = 0, endingHour = 24 } = settings;
  return stepWidth * (endingHour - startingHour);
}
